/* eslint-disable no-param-reassign */
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export type FieldBackupsState = Record<string, string>;

const initialState: FieldBackupsState = {};

const fieldBackupsSlice = createSlice({
  name: 'fieldBackups',
  initialState,
  reducers: {
    setFieldBackup: (
      state,
      action: PayloadAction<{ fieldId: string; backup: string }>
    ) => {
      const { fieldId, backup } = action.payload;

      state[fieldId] = backup;
    },
    clearFieldBackup: (state, action: PayloadAction<string>) => {
      const fieldId = action.payload;

      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete state[fieldId];
    },
    clearAllFieldBackups: () => initialState,
  },
});

export const fieldBackupsActions = fieldBackupsSlice.actions;
export const fieldBackupsReducer = fieldBackupsSlice.reducer;
